import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Switch } from "@/components/ui/switch";

export const LiveChoices = ({ bare = false }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/me/live-choices").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  useEffect(() => { if (rows && window.location.hash === "#live-updates") document.getElementById("live-updates")?.scrollIntoView({ behavior: "smooth" }); }, [rows]);
  const toggle = async (r) => {
    try {
      const { data } = await api.post(`/live/${r.id}/follow`);
      setRows((xs) => xs.map((x) => (x.id === r.id ? { ...x, following: data.following } : x)));
      toast.success(data.following ? `${r.title} updates will appear in your feed` : `${r.title} removed from your feed`);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <section id={bare ? undefined : "live-updates"} className={bare ? "space-y-1" : "surface space-y-1 p-5 sm:p-6"} data-testid={bare ? "feed-live-choices" : "pref-live-choices"}>
      {!bare && <h2 className="text-xl">Middle Live in your feed</h2>}
      <p className="text-xs text-slate-500">Choose the Live issues you want updates for. New verified updates appear in your Feed and you get a notification. Changes save straight away.</p>
      {rows === null ? <p className="py-3 text-sm text-slate-500">Loading…</p> : !rows.length ? <p className="py-3 text-sm text-slate-500">No Live issues right now.</p> : (
        <div className="divide-y divide-border">{rows.map((r) => (
          <div key={r.id} className="flex items-center justify-between gap-4 py-3">
            <div className="min-w-0"><p className="text-sm font-medium">{r.title}</p><p className="text-xs text-slate-500">{r.category}</p></div>
            <Switch className="data-[state=unchecked]:bg-slate-300" checked={r.following} onCheckedChange={() => toggle(r)} data-testid={`${bare ? "feed" : "pref"}-live-${r.id}`} aria-label={`Updates for ${r.title}`} />
          </div>
        ))}</div>
      )}
    </section>
  );
};
